import { render } from "./simpleHead.vue?vue&type=template&id=49d5704c&scoped=true"
import script from "./simpleHead.vue?vue&type=script&lang=js"
export * from "./simpleHead.vue?vue&type=script&lang=js"

import "./simpleHead.vue?vue&type=style&index=0&id=49d5704c&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d5704c"]])

export default __exports__